module.exports = __webpack_public_path__ + "img/template_with_header.b2351b86.jpg";